import { simpleFetch, simpleFetchWithHttp } from './customFetch';

const emailPreferencesHeadersV2 = {
  'Content-Type': 'application/json',
  Accept: 'application/vnd.fabfitfun.v2+json',
};

const emailPreferencesHeadersV1 = {
  'Content-Type': 'application/json',
  Accept: 'application/vnd.fabfitfun.v1+json',
};

export const getEmailPreferences = () =>
  simpleFetch(
    '/maillists/self/email-preferences',
    { headers: { ...emailPreferencesHeadersV2 } },
    process.env.REACT_APP_MAIL_LIST_API,
  );

export const updateEmailPreferences = (option) =>
  simpleFetch(
    '/maillists/self/email-preferences',
    {
      method: 'POST',
      body: JSON.stringify({ optionEmailPreferences: option }),
      headers: { ...emailPreferencesHeadersV1 },
    },
    process.env.REACT_APP_MAIL_LIST_API,
  );

export const postContactUsForm = (formData) =>
  simpleFetchWithHttp(
    '/api/1/send/email/cx',
    {
      method: 'POST',
      body: JSON.stringify(formData),
    },
    process.env.REACT_APP_MAIL_LIST_API,
  );

export const subscribeSms = () =>
  simpleFetch(
    '/maillists/v3/self/subscribe/sms',
    {
      method: 'POST',
    },
    process.env.REACT_APP_MAIL_LIST_API,
  );
